import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      enums: {
        OPERATOR: 'Оператор',
        SELF_MADE: 'Собственное производство',
      },
    }
  }
}
